import React, { useContext, useEffect, useState } from "react";
import Link from "next/link";

import { GetSolNftDataContext } from "../../../contexts/SolNftContext";
import { SOLANA_DECIMAL } from "../../../config";
import { useRouter } from "next/router";
import { useWallet } from "@solana/wallet-adapter-react";
import { collection_activity_item_data } from "../../../data/collection_data";
const Sol_Activity_item = ({ showState }) => {
  const { publicKey } = useWallet();
  const router = useRouter();
  const [filterVal, setFilterVal] = useState([]);

  const { activityData } = useContext(GetSolNftDataContext);

  const [filterData, setfilterData] = useState(
    collection_activity_item_data.map((item) => {
      const { category } = item;
      return category;
    })
  );

  const handleFilterByCollection = (collectionAddr) => {
    if (collectionAddr !== "") {
      setFilterVal(
        activityData.filter((data) => data.collectionAddr === collectionAddr)
      );
    } else {
      setFilterVal(
        activityData.filter((data) => data.seller === publicKey?.toBase58())
      );
    }
  };

  useEffect(() => {
    const walletAddr = publicKey?.toBase58();
    if (showState === "all") {
      setFilterVal(activityData);
    } else if (showState === "seller") {
      setFilterVal(activityData.filter((data) => data.seller === walletAddr));
    } else {
      router.query.collection &&
        setFilterVal(
          activityData.filter(
            (data) => data.collectionAddr === router.query.collection
          )
        );
    }
  }, [activityData, router, publicKey]);

  const handleFilters = (category) => {
    if (category === "All") {
      setFilterVal(activityData);
    } else if (category === "listed") {
      setFilterVal(activityData.filter((data) => data.txType !== 4));
    } else {
      setFilterVal(activityData.filter((data) => data.txType === 4));
    }
  };

  return (
    <>
      {/* <!-- Activity Tab --> */}
      <div className="tab-pane fade">
        {/* <!-- Records / Filter --> */}
        <div className="lg:flex">
          {/* <!-- Records --> */}
          <div className="mb-10 shrink-0 basis-8/12 space-y-5 lg:mb-0 lg:pr-10">
            {filterVal.map((item, index) => (
              <Link href={""} key={index}>
                <a className="bg-jacarta-900 gap-4 dark:border-jacarta-700 border-jacarta-700 rounded-2.5xl relative flex justify-center items-center border p-2 transition-shadow hover:shadow-lg">
                  <img
                    src={item.imgUrl}
                    alt={""}
                    height={35}
                    width={35}
                    objectfit="cover"
                    className="rounded-2lg object-cover w-[45px] h-[45px]"
                    loading="lazy"
                  />

                  <div>
                    <h3 className="font-display  mb-1 text-base font-semibold text-jacarta-300">
                      TokenId : #{item.tokenId}
                    </h3>
                    <span className="dark:text-jacarta-200 text-jacarta-500 mb-3 block text-sm font-bold">
                      {item.solPrice / SOLANA_DECIMAL} Sol
                    </span>
                    {/* <span className="text-jacarta-300 block text-xs">
                      {item?.txType === 4
                        ? item.sold.split(".")[0]
                        : item?.listing_time.split(".")[0]}
                    </span> */}
                  </div>

                  <div
                    className={`cdborder-jacarta-600 ml-auto rounded-2xl ${
                      item?.txType !== 4 ? "bg-green " : "bg-accent-dark"
                    } px-3 py-1 text-white`}
                  >
                    {item?.txType === 4 ? "Sold" : "List"}
                    {/* <svg className="icon fill-jacarta-700 dark:fill-white h-6 w-6">
                          <use xlinkHref={`/icons.svg#icon-${category}`}></use>
                        </svg> */}
                  </div>
                </a>
              </Link>
            ))}
          </div>

          {/* <!-- Filters --> */}
          <aside className="basis-4/12 lg:pl-5">
            <form action="search" className="relative mb-12 block">
              <input
                type="search"
                className="text-jacarta-700 placeholder-jacarta-500 focus:ring-accent w-full rounded-2xl border py-[0.6875rem] px-4 pl-10 dark:border-transparent bg-jacarta-900 dark:text-white dark:placeholder-white"
                placeholder="Search by Collection"
                onChange={(e) => handleFilterByCollection(e.target.value)}
              />
              <button
                type="submit"
                className="absolute left-0 top-0 flex h-full w-12 items-center justify-center rounded-2xl"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="24"
                  height="24"
                  className="fill-jacarta-500 h-4 w-4 dark:fill-white"
                >
                  <path fill="none" d="M0 0h24v24H0z"></path>
                  <path d="M18.031 16.617l4.283 4.282-1.415 1.415-4.282-4.283A8.96 8.96 0 0 1 11 20c-4.968 0-9-4.032-9-9s4.032-9 9-9 9 4.032 9 9a8.96 8.96 0 0 1-1.969 5.617zm-2.006-.742A6.977 6.977 0 0 0 18 11c0-3.868-3.133-7-7-7-3.868 0-7 3.132-7 7 0 3.867 3.132 7 7 7a6.977 6.977 0 0 0 4.875-1.975l.15-.15z"></path>
                </svg>
              </button>
            </form>
            <h3 className="font-display text-jacarta-500 mb-4 font-semibold dark:text-white">
              Filters
            </h3>
            <div className="flex">
              {filterData.map((category, i) => {
                return (
                  <button
                    className={
                      filterVal === i
                        ? "dark:border-jacarta-600 group bg-accent border-jacarta-100 mr-2.5 mb-2.5 inline-flex items-center rounded-xl border px-4 py-3 border-transparent text-white dark:border-transparent"
                        : "dark:border-jacarta-600 dark:bg-jacarta-700 group dark:hover:bg-accent hover:bg-accent border-jacarta-100 mr-2.5 mb-2.5 inline-flex items-center rounded-xl border bg-white px-4 py-3 hover:border-transparent hover:text-white dark:text-white dark:hover:border-transparent"
                    }
                    key={i}
                    onClick={() => {
                      handleFilters(category);
                    }}
                  >
                    <svg
                      className={
                        filterVal === i
                          ? "icon mr-2 h-4 w-4 fill-white"
                          : "icon fill-jacarta-700 mr-2 h-4 w-4 group-hover:fill-white dark:fill-white"
                      }
                    >
                      <use xlinkHref={`/icons.svg#icon-${category}`}></use>
                    </svg>
                    <span className="text-2xs font-medium capitalize">
                      {category}
                    </span>
                  </button>
                );
              })}
            </div>
          </aside>
        </div>
      </div>
    </>
  );
};

export default Sol_Activity_item;
